export default "__VITE_ASSET__4ddcceb8__"